import React from 'react';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { SnackbarVariant } from '@eas/common-web';
import { workOrderBulkApi } from './bulk-operations-api';

export const useStyles = makeStyles((theme) => ({
  moreIcon: {
    color: theme.palette.grey[500],
    display: 'flex',
    fontSize: '16px',
  },
  bullet: {
    width: 12,
    height: 12,
    borderRadius: 12,
    marginRight: 8,
    marginLeft: 14,
    flexShrink: 0,
  },
}));

export const ResyncBulkFormButton = ({
  disabled,
  ids,
  showSnackbar,
  afterSubmit,
}: {
  disabled?: boolean;
  ids: string[];
  showSnackbar: (message: string, variant: SnackbarVariant) => void;
  afterSubmit: () => void;
}) => {
  return (
    <Button
      onClick={() => {
        workOrderBulkApi.resync(ids);
        showSnackbar(
          'Synchronizácia PP bola spustená. Po dokončení budete informovaný notifikáciou.',
          SnackbarVariant.SUCCESS
        );
        afterSubmit();
      }}
      color="primary"
      variant="contained"
      disabled={disabled}
      style={{ fontSize: '12px', padding: '4px 8px' }}
    >
      Synchronizovať
    </Button>
  );
};
